import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '../utils/utils.service';
import { ResponseService } from 'src/app/core/models/response-service.model';
import * as dayjs from 'dayjs';
import { getFirebaseBackend } from 'src/app/authUtils';

@Injectable({ providedIn: 'root' })
export class UserService {
	constructor(
		private oldDataSrv: OldDataService,
		private http: HttpClient,
		private utils: UtilsService,
	) {}

	getActiveEmployees() {
		const url = `${environment.api}user/get_employees`;
		return this.http.get(url);
	}

	getClientUsersSelect() {
		const url = `${environment.api}user/get_client_users_select`;
		return this.http.get(url);
	}

	sendLinkCreationCustomer(link: string, email: string) {
		const url = `${environment.api}user/send_link_creation_customer`;
		const formData: any = this.utils.jsonToFormData({ link, email });
		return this.http.post(url, formData);
	}

	getUserByAlias(alias) {
		const url = `${environment.api}user/get_user_by_alias`;
		const formData: any = this.utils.jsonToFormData({ alias });
		return this.http.post(url, formData);
	}

	getUserById(id) {
		const url = `${environment.api}user/get_user_by_id`;
		const formData: any = this.utils.jsonToFormData({ id });
		return this.http.post(url, formData);
	}

	getClientUserStatus(status) {
		const url = `${environment.api}user/${status}/get_client_users_status`;
		return this.http.get(url);
	}

	getEmployeeUsersStatus(status) {
		const url = `${environment.api}user/${status}/get_employee_users_status`;
		return this.http.get(url);
	}

	createEmployeeUser(userData: any) {
		const url = `${environment.api}user/create_employee_user`;
		const formData: any = this.utils.jsonToFormData(userData);
		return this.http.post(url, formData);
	}

	createSingleUser(data: any) {
		const url = `${environment.api}user/create_single_user`;
		const formData: any = this.utils.jsonToFormData(data);
		return this.http.post(url, formData);
	}

	createCompleteUser(data: any) {
		const url = `${environment.api}user/create_complete_customer`;
		const formData: any = this.utils.jsonToFormData(data);
		return this.http.post(url, formData);
	}

	getUserModules(user_id: number) {
		const url = `${environment.api}user/${user_id}/get_modules`;
		return this.http.get(url);
	}

	getEmployeesForSelect() {
		const url = `${environment.api}user/get_employees_select`;
		return this.http.get(url);
	}

	getAllAlias() {
		const url = `${environment.api}user/get_all_alias`;
		return this.http.get(url);
	}

	getUserAssignedCampaigns(user_id) {
		const url = `${environment.api}user/${user_id}get_user_assigned_campaigns_by_id`;
		return this.http.get(url);
	}

	assignCampaignToUser(payload) {
		const url = `${environment.api}user/assign_campaign_to_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	removeCampaignFromUser(payload) {
		const url = `${environment.api}user/remove_campaign_from_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	removeAllCampaignsFromUser(payload) {
		const url = `${environment.api}user/remove_all_campaigns_from_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	assignAllCampaignsToUser(payload) {
		const url = `${environment.api}user/assign_all_campaigns_to_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getUserdisposByData(payload) {
		const url = `${environment.api}user/get_user_dispo_log_by_date`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	updateData(payload) {
		const url = `${environment.api}user/update_data`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	setModulesToUser(payload) {
		const url = `${environment.api}user/set_modules_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	deactivateUser(user_id) {
		const url = `${environment.api}user/${user_id}/deactivate_user`;
		return this.http.get(url);
	}

	activateUser(user_id) {
		const url = `${environment.api}user/${user_id}/activate_user_by_id`;
		return this.http.get(url);
	}

	deactivatePremiumUser(user_id) {
		const url = `${environment.api}user/${user_id}/deactivate_user_premium`;
		return this.http.get(url);
	}

	activatePremiumUser(user_id) {
		const url = `${environment.api}user/${user_id}/activate_user_premium`;
		return this.http.get(url);
	}

	unsetMainAccount(user_id) {
		const url = `${environment.api}user/${user_id}/unset_main_account`;
		return this.http.get(url);
	}

	setMainAccount(user_id) {
		const url = `${environment.api}user/${user_id}/set_main_account`;
		return this.http.get(url);
	}

	testEmail(payload) {
		const url = `${environment.api}user/test_email`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	addCustomerType(payload) {
		const url = `${environment.api}user/add_customer_type`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getCustomersByClient(user_id) {
		const url = `${environment.api}user/${user_id}/get_customers_by_client`;
		return this.http.get(url);
	}

	deactivateCustomer(user_id) {
		const url = `${environment.api}user/${user_id}/deactivate_customer`;
		return this.http.get(url);
	}

	addContractClient(payload) {
		const url = `${environment.api}user/add_contract_client`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getClientContracts(user_id) {
		const url = `${environment.api}user/${user_id}/get_contracts_client`;
		return this.http.get(url);
	}

	getUserCampaigns(alias) {
		const url = `${environment.api}user/${alias}/get_user_campaigns`;
		return this.http.get(url);
	}

	testUserEmail(email, name) {
		const url = `${environment.api}user/test_user_email`;
		const formData: any = this.utils.jsonToFormData({ email, name });
		return this.http.post(url, formData);
	}

	updateClientUser(payload) {
		const url = `${environment.api}user/update_client_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	updateEmployeeUser(payload) {
		const url = `${environment.api}user/update_employee_user`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	saveAction(action: string) {
		const user = getFirebaseBackend()?.getAuthenticatedUser();
		const payload = {
			user_id: user?.IdUser,
			action_description: action,
			date_time: dayjs().format('DD-MM-YYYY HH:mm:ss'),
			ipv4: user?.ipv4,
			ipv6: user?.ipv6,
			portal: 'CAL',
		};

		const url = `${environment.api}utils/save_user_action`;
		const formData = this.utils.jsonToFormData(payload);

		this.http.post<ResponseService>(url, formData).subscribe({
			next: (res) => {
				console.info('Acción guardada:', res);
			},
			error: (err) => {
				console.error('Error guardando acción:', err);
			},
		});
	}

	startCall(data: { campaign: number | string; source_view: string; primary_phone: string; first_name: string; last_name: string }) {
		const user = getFirebaseBackend()?.getAuthenticatedUser();
		const payload = {
			userId: user?.IdUser,
			...data,
		};

		const url = `${environment.api}caller/callers_calls/start_call`;
		const formData = this.utils.jsonToFormData(payload);

		this.http.post<ResponseService>(url, formData).subscribe({
			next: (res) => console.info('Llamada registrada:', res),
			error: (err) => console.error('Error registrando llamada:', err),
		});
	}

	getRingCentralCalls(payload) {
		const formData = this.utils.jsonToFormData(payload);
		const url = `${environment.api}RingCall/get_ringcentral_calls`;
		return this.http.post(url, formData);
	}

	saveCurrentCampaign(userId: number, campaignId: string) {
		const url = `${environment.api}campaigns/save_current_campaign`;
		const formData = new FormData();
		formData.append('user_id', userId.toString());
		formData.append('campaign_id', campaignId);

		return this.http.post(url, formData);
	}
}
